<button class="quickFilterButton" [class._active]="active" [ngStyle]="{'background-color': color}">
    <span class="quickFilterButton-mask"
          [style.opacity]="active ? '0' : '1'" [style.visibility]="active ? 'hidden' : 'visible'"></span>
    <span class="quickFilterButton-radio"></span>
    <span class="quickFilterButton-label">
        <ng-content></ng-content>
    </span>
</button>
